export default __webpack_public_path__ + "static/AlgaeBloomsSmall-28f961e788863e87d3855704c1254504.png";